import React from "react";
import { Select as MantineSelect, SelectProps, useMantineTheme } from "@mantine/core";

interface CustomSelectProps extends Omit<SelectProps, "styles"> {}

/**
 * Select - Themed select dropdown component
 * Usage: <Select label="Choose option" data={options} />
 */
export const Select: React.FC<CustomSelectProps> = ({ ...props }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <MantineSelect
      {...props}
      styles={{
        label: {
          color: other.textPrimary,
          marginBottom: "0.5rem",
          fontWeight: 500,
        },
        input: {
          backgroundColor: "rgba(26, 20, 16, 0.85)",
          border: "1px solid rgba(245, 238, 224, 0.15)",
          color: other.textPrimary,
          "&:focus": {
            borderColor: other.focusRingColor,
            boxShadow: other.focusRing,
          },
        },
        dropdown: {
          backgroundColor: "rgba(26, 20, 16, 0.98)",
          border: "1px solid rgba(212, 85, 43, 0.2)",
        },
        option: {
          color: other.textPrimary,
          "&:hover": {
            backgroundColor: "rgba(212, 85, 43, 0.12)",
          },
          "&[data-selected]": {
            backgroundColor: other.signatureTerracotta,
            color: other.textPrimary,
          },
        },
        error: {
          color: other.errorText,
        },
      }}
    />
  );
};

export default Select;
